
import { createSlice } from '@reduxjs/toolkit';

const appsDashboardSlice = createSlice({
  name: 'appsDashboard',
  initialState: {
    data: null,
    error: null,
  },
  reducers: {
    fetchDataStart: (state) => {
      state.data = null;
      state.error = null;
    },
    fetchDataSuccess: (state, action) => {
      state.data = action.payload;
    },
    fetchDataFailure: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { fetchDataStart, fetchDataSuccess, fetchDataFailure } = appsDashboardSlice.actions;
export default appsDashboardSlice.reducer;
